import { SxProps, Theme, TypographyProps } from '@mui/material';
import { defaultContainerStyling, secondaryContainerStyling } from '../../styles/sxStyling';

// Main Container Styles
const containerStyles: SxProps = {
  minWidth: { xs: '100%', md: '49%', lg: '33%' },
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '80vh',
  minHeight: '44rem',
};

// Control Section Styles
export const controlSectionStyles: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  maxHeight: '3rem',
  gap: 1,
};

export const iconButtonStyles: SxProps<Theme> = {
  padding: { xs: 0.5, md: 1 },
};

// Paper Container Styles
export const paperContainerStyles: SxProps<Theme> = {
  ...defaultContainerStyling,
  ...containerStyles,
  overflow: 'clip',
  width: '100%',
  backgroundColor: 'background',
  p: 2,
  gap: 2,
};

// Tile Container Styles
export const tilesContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '33rem',
  height: '100%',
  gap: 0.8,
  justifyContent: 'flex-start',
};

export const tileContainerStyles = {
  ...secondaryContainerStyling,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  minHeight: '4rem',
  height: '100%',
  maxHeight: '5.4rem',
  px: 1.5,
  border: '1px solid var(--border-light)',
  backgroundColor: 'background.paper',
  gap: 1,
  overflow: 'hidden',
  fontSize: '0.875rem',
};

const tileDividerSectionStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

export const tileSectionLeftStyles: SxProps<Theme> = {
  ...tileDividerSectionStyles,
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  gap: 0.5,
  justifyContent: 'center',
};

export const tileSectionRightStyles: SxProps<Theme> = {
  ...tileDividerSectionStyles,
  flexShrink: 0,
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'end',
  maxWidth: '40%',
};

// Tile Header Section Styles (Tasks and Events)
export const tileHeaderSectionStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 1,
};
export const tileHeaderLeftStyles: SxProps<Theme> = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textDecoration: 'underline',
  fontSize: '1em',
  fontWeight: 500,
};
// Text Container for AppLink Wrappers
export const textContainerStyles: SxProps<Theme> = {
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'block',
  color: 'var(--text-secondary)',
};

// Secondary Tile Section (Event Date or Employee Name)
export const tileSecondarySectionStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
};
export const secondaryTextStyles: SxProps<Theme> = { display: 'flex', alignItems: 'center', maxHeight: '1.4em' };
export const secondaryLabelStyles: SxProps<Theme> = { fontSize: '0.85em', color: 'text.secondary' };
export const secondaryIconStyles: SxProps<Theme> = { fontSize: '1.1em', mr: 0.5 };
// Footer Styles
export const footerContainerStyles: SxProps<Theme> = {
  display: 'flex',
  gap: 2,
};

export const footerCountDivStyles: SxProps<Theme> = {
  ...secondaryContainerStyling,
  display: 'flex',
  border: '1px solid var(--border-light)',
  flexDirection: 'column',
  width: '50%',
  p: 1.4,
  backgroundColor: 'background.paper',
};

export const footerCountProps: TypographyProps = {
  align: 'center',
  variant: 'h5',
  fontSize: '1.5rem',
  fontWeight: 300,
};
export const footerLabelProps: TypographyProps = {
  align: 'center',
  fontSize: '12px',
  color: 'text.secondary',
};

//Summary Panel Styles
export const summaryContainerStyles: SxProps<Theme> = {
  ...defaultContainerStyling,
  ...containerStyles,
  p: 3,
  pt: 0,
  minWidth: { xs: '100%', md: '30%' },
};
export const summaryHeaderStyles: SxProps<Theme> = { height: '3rem', fontWeight: 600, pt: 1 };
export const summaryCardStyles: SxProps<Theme> = {
  ...secondaryContainerStyling,
  minHeight: '7rem',
  height: '100%',
  p: 2,
  border: '1px solid var(--border-light)',
};
export const summaryItemHeaderStyles: SxProps<Theme> = { display: 'flex', gap: 2, borderRadius: 1, width: '100%', alignItems: 'center' };
export const summaryItemIconStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  borderRadius: 2,
  backgroundColor: 'var(--primary-light)',
};
export const summaryItemCountStyles: TypographyProps = { fontWeight: 'normal', fontSize: 32 };
export const summaryItemLabelStyles: TypographyProps = { fontWeight: 500, color: 'var(--text-secondary)', paddingTop: '5px' };

export const dashboardSelectSx = {
  minWidth: 120,
  maxHeight: 34,
};
